import { useTranslation } from "react-i18next";
import Wrapper from "./components/Wrapper";
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPasswordNotAuthorized = () => {
  const { t } = useTranslation();
  return (
    <Wrapper title={t("resetPassword.title")}>
      <ResetPasswordForm showSignInLink />
    </Wrapper>
  );
};

export default ResetPasswordNotAuthorized;
